import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/bookings/v1/categories',
        destPath: '/v1/categories',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/bookings/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/services-server/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/services-server/v1/batch/categories',
        destPath: '/v1/batch/categories',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/bookings/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/bookings/v1/batch/categories',
        destPath: '/v1/batch/categories',
      },
      {
        srcPath: '/_api/services-server/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/services-server/v1/batch/categories',
        destPath: '/v1/batch/categories',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/bookings/v1/categories',
        destPath: '/v1/categories',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/bookings/v1/categories',
        destPath: '/v1/categories',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/bookings/v1/categories',
        destPath: '/v1/categories',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/categories-proxy',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/services-server/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/services-server/v1/batch/categories',
        destPath: '/v1/batch/categories',
      },
    ],
    'bookings._base_domain_': [
      {
        srcPath: '/_api/services-server/v1/categories',
        destPath: '/v1/categories',
      },
      {
        srcPath: '/_api/services-server/v1/batch/categories',
        destPath: '/v1/batch/categories',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_bookings_categories';

/**
 * Retrieves all categories.
 * @deprecated
 */
export function list(payload: object): RequestOptionsFactory<any> {
  function __list({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v1.category',
      method: 'GET' as any,
      methodFqn: 'com.wixpress.bookings.services.api.v1.CategoriesService.List',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
        protoPath: '/v1/categories',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __list;
}

/**
 * Creates a category.
 * @deprecated
 */
export function create(payload: object): RequestOptionsFactory<any> {
  function __create({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v1.category',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.bookings.services.api.v1.CategoriesService.Create',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
        protoPath: '/v1/categories',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __create;
}

/**
 * Updates a category.
 *
 *
 * Each time the category is updated, revision increments by 1. You must include
 * the number of the existing revision when updating the category. This ensures
 * you're working with the latest service information and prevents unintended
 * overwrites.
 * @deprecated
 */
export function update(payload: object): RequestOptionsFactory<any> {
  function __update({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v1.category',
      method: 'PUT' as any,
      methodFqn:
        'com.wixpress.bookings.services.api.v1.CategoriesService.Update',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
        protoPath: '/v1/categories/{category.id}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __update;
}

/**
 * Deletes a category.
 *
 *
 * You can specify `{"deleteServices": true}` to also delete all associated
 * services. Learn more about [deleting a service](https://dev.wix.com/docs/rest/business-solutions/bookings/services/services-v2/delete-service).
 * @deprecated
 */
export function _delete(payload: object): RequestOptionsFactory<any> {
  function ___delete({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.bookings.v1.category',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.bookings.services.api.v1.CategoriesService._delete',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressBookingsServicesApiV1CategoriesServiceUrl({
        protoPath: '/v1/categories/{id}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return ___delete;
}
